// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SimplySignButton_reset-list_14wVJ{margin:0;padding:0;list-style:none;display:block}.SimplySignButton_uppercase-sm_2yS70{font-size:12px;text-transform:uppercase;letter-spacing:.03667em}.SimplySignButton_icon_21ZY1{display:block;width:125px;height:auto}", ""]);
// Exports
exports.locals = {
	"reset-list": "SimplySignButton_reset-list_14wVJ",
	"uppercase-sm": "SimplySignButton_uppercase-sm_2yS70",
	"icon": "SimplySignButton_icon_21ZY1"
};
module.exports = exports;
